var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKaraoke = function SvgKaraoke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.95,
    cy: 6.05,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "rotate(45 15.95 6.05)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12.06 6.404 2.162 17.717l2.121 2.122 11.314-9.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.084 15.447a.75.75 0 0 1 .046 1.06l-3.834 4.183a.75.75 0 0 1-1.106 0l-1.743-1.902a.75.75 0 0 1 1.106-1.013l1.19 1.298 3.282-3.58a.75.75 0 0 1 1.06-.046",
    clipRule: "evenodd"
  })));
};
export default SvgKaraoke;